import React from "react"
import { Link } from "react-router-dom"
import removeMd from "remove-markdown"
import TweenLite, { Power2 } from "gsap/umd/TweenMax"

// Components
import "./style.css"

const HistoryPreviewBox = ({ title, description, image, link }) => {
    const text = removeMd(description) // Fjerner markdown markup
    const textSplit = text.split(" ").slice(0, 20) // Henter et utdrag
    const descriptionPreview = textSplit.join(" ")

    const fadeInImage = (event) => {
        TweenLite.to(event.target, 0.3, { opacity: 1, ease: Power2.easeIn })
    }

    return (
        <Link to={link} className="history-preview-wrapper">
            <div className="history-preview-box highlighted-box">
                <div className="history-preview-image-box">
                    <img
                        className="img-res history-preview-image-box__image"
                        src={image}
                        alt={title}
                        style={{ opacity: 0 }}
                        ref={comp => { this.image = comp }}
                        onLoad={fadeInImage} />
                </div>

                <div className="history-preview-box-text-wrapper">
                    <h4 className="history-preview-box-text-wrapper__title">{ title }</h4>
                    <p className="history-preview-box-text-wrapper__text">{ descriptionPreview }...</p>
                </div>

            </div>
        </Link>
    )
}

export default HistoryPreviewBox



// WEBPACK FOOTER //
// ./src/components/HistoryPreviewBox/index.js